import { SvgIcon, SvgIconProps } from '@mui/material';

const NotificationsOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="NotificationsOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C10.6393 1 9.53494 2.08311 9.50081 3.4355C6.57023 4.4944 5 7.3374 5 10.5V14.6492L3 17.1492V19.5H9V20C9 21.6569 10.3431 23 12 23C13.6569 23 15 21.6569 15 20V19.5H21V17.1492L19 14.6492V10.5C19 7.34635 17.4213 4.49696 14.4992 3.4364C14.4656 2.08359 13.361 1 12 1ZM13 19.5H11V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.5ZM11.5 3.5C11.5 3.22228 11.7223 3 12 3C12.2777 3 12.5 3.22228 12.5 3.5V4.97011L13.2687 5.15288C15.5762 5.70153 17 7.77963 17 10.5V15.3508L18.7194 17.5H5.28063L7 15.3508V10.5C7 7.76874 8.41437 5.70184 10.7306 5.15306L11.5 4.97075V3.5Z"
      />
    </SvgIcon>
  );
};

export default NotificationsOutlined;
